export class Contact {

    public id: string;
    public personnummer: string;
    public foreignPersonnummer: string;
    public firstname: string;
    public lastname: string;
    public eMail: string;
    public mobilePhone: string;
    public primaryContactLanguage: number;
    public addressCO: string;
    public addressLine1: string;
    public addressPostalCode: string;
    public addressCity: string;
    public addressStateOrProvince: string;
    public addressCountry: string;
    public occupation: number[];
    public relationToUU: string;
    public interestedInMentorship: boolean;
    public selectedCountry: string;
    public subscriptionOfNewsletterAndMagazine: boolean;
    public informationAndInvitationsFromAlumniNetwork: boolean;
    public informationAndInvitationsFromDisciplinaryDomain: boolean;
    public informationAndInvitationsFromYourAssociation: boolean;
    public gotlandsNation: boolean;
    public gastrikeHalsingeNation: boolean;
    public goteborgsNation: boolean;
    public kalmarNation: boolean;
    public norrlandsNation: boolean;
    public smalandsNation: boolean;
    public stockholmsNation: boolean;
    public sodermanlandsNerikesNation: boolean;
    public uplandsNation: boolean;
    public varmlandsNation: boolean;
    public vastgotaNation: boolean;
    public vastmanlandsDalaNation: boolean;
    public ostgotaNation: boolean;
    public uppsalaStudentkar: boolean;
    public uppsalaTeknologOchNaturvetarkarUTN: boolean;
    public uppsalaekonomerna: boolean;
    public farmacevtiskaStudentkaren: boolean;
    public juridiskaForeningen: boolean;
    public gotlandsStudentkarRindi: boolean;

  public Contact() {
        this.id = '';
        this.personnummer = '';
        this.foreignPersonnummer = '';
        this.firstname = '';
        this.lastname = '';
        this.eMail = '';
        this.mobilePhone = '';
        this.primaryContactLanguage = 0;
        this.addressCO = '';
        this.addressLine1 = '';
        this.addressPostalCode = '';
        this.addressCity = '';
        this.addressStateOrProvince = '';
        this.addressCountry = '';
        this.occupation = [];
        this.relationToUU = '';
        this.interestedInMentorship = false;
        this.selectedCountry = '';
        this.subscriptionOfNewsletterAndMagazine = true;
        this.informationAndInvitationsFromAlumniNetwork = true;
        this.informationAndInvitationsFromDisciplinaryDomain = true;
        this.informationAndInvitationsFromYourAssociation = true;
        this.gotlandsNation = false;
        this.gastrikeHalsingeNation= false;
        this.goteborgsNation= false;
        this.kalmarNation= false;
        this.norrlandsNation = false;
        this.smalandsNation = false;
        this.stockholmsNation = false;
        this.sodermanlandsNerikesNation = false;
        this.uplandsNation = false;
        this.varmlandsNation = false;
        this.vastgotaNation = false;
        this.vastmanlandsDalaNation = false;
        this.ostgotaNation = false;
        this.uppsalaStudentkar = false;
        this.uppsalaTeknologOchNaturvetarkarUTN = false;
        this.uppsalaekonomerna = false;
        this.farmacevtiskaStudentkaren = false;
        this.juridiskaForeningen = false;
        this.gotlandsStudentkarRindi = false;
    }
}
